import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableComissionsView.
 * @extends JetView
 */
export default class tableComissionsView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user ID from parameters

        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border', // CSS classes for styling
            id: 'datatable', // ID for the datatable
            select: true, // Enable row selection
            minHeight: 300, // Minimum height of the datatable
            columns: [
                // Column definitions
                {
                    id: 'rating', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: 'Editar', // Tooltip text
                    template: function (obj) {
                        // Template function for rendering
                        if (devConfig.getPermAction('betShopComissionsEdit', 'Edit')) {
                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                        } else {
                            return ''; // No icon if permission denied
                        }
                    },
                },
                {
                    id: 'Id', // Column ID
                    header: 'Id', // Column header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                    hidden: true, // Hidden column
                },
                {
                    id: 'ProductName', // Column ID
                    header: _('Producto'), // Localized column header
                    width: 250, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ComissionLevel1', // Column ID
                    header: _('Comisión Nivel 1'), // Localized column header
                    width: 120, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ComissionLevel2', // Column ID
                    header: _('Comisión Nivel 2'), // Localized column header
                    width: 220, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ComissionLevel3', // Column ID
                    header: _('Comisión Nivel 3'), // Localized column header
                    width: 220, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ComissionLevel4', // Column ID
                    header: _('Comisión Nivel 4'), // Localized column header
                    width: 220, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ComissionLevelBetShop', // Column ID
                    header: _('Comisión Punto'), // Localized column header
                    width: 220, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // Data source URL
            url: devConfig.geturlApi() + 'es/BetShop/GetAgentComissionItems?FromId=' + cur_user + '&',
            onClick: {
                // Click event handler
                edit: function (euv, id) {
                    $$('editwinComissions').show(); // Show edit window on click
                },
            },
        };
    }

    /**
     * Initializes the datatable and its events.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // Data URL for the grid
        const cur_user = this.getParam('user', true); // Current user ID from parameters

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event on item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        var popup = webix.ui({
            // Create edit window
            view: 'window',
            id: 'editwinComissions', // Window ID
            head: {
                view: 'toolbar', // Toolbar for the window
                cols: [
                    { view: 'label', label: _('Editar Comisión') }, // Label in toolbar
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'form', // Form inside the window
                id: 'editformComissions', // Form ID
                elements: [
                    // Form elements
                    {
                        view: 'text', // Text input for ID
                        label: 'Id',
                        labelWidth: 150,
                        name: 'Id',
                        readonly: true, // Read-only field
                        hidden: true, // Hidden field
                    },
                    {
                        view: 'text', // Text input for Product Name
                        label: _('Producto'),
                        labelWidth: 150,
                        name: 'ProductName',
                        readonly: true, // Read-only field
                    },
                    {
                        view: 'text', // Text input for Commission Level 1
                        label: _('Comisión Nivel 1'),
                        labelWidth: 150,
                        name: 'ComissionLevel1',
                        readonly: false, // Editable field
                        type: 'number', // Number input type
                    },
                    {
                        view: 'text', // Text input for Commission Level 2
                        label: _('Comisión Nivel 2'),
                        labelWidth: 150,
                        name: 'ComissionLevel2',
                        readonly: false, // Editable field
                        type: 'number', // Number input type
                    },
                    {
                        view: 'text', // Text input for Commission Level 3
                        label: _('Comisión Nivel 3'),
                        labelWidth: 150,
                        name: 'ComissionLevel3',
                        readonly: false, // Editable field
                        type: 'number', // Number input type
                    },
                    {
                        view: 'text', // Text input for Commission Level 4
                        label: _('Comisión Nivel 4'),
                        labelWidth: 150,
                        name: 'ComissionLevel4',
                        readonly: false, // Editable field
                        type: 'number', // Number input type
                    },
                    {
                        view: 'text', // Text input for Commission Level Bet Shop
                        label: _('Comisión Punto'),
                        labelWidth: 150,
                        name: 'ComissionLevelBetShop',
                        readonly: false, // Editable field
                        type: 'number', // Number input type
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide window on click
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('editformComissions').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to save data
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'BetShop/SaveComissions',
                                            '{"FromId":"' +
                                                cur_user +
                                                '","Id":"' +
                                                values.Id +
                                                '","ProductName":"' +
                                                values.ProductName +
                                                '","ComissionLevel1":"' +
                                                values.ComissionLevel1 +
                                                '","ComissionLevel2":"' +
                                                values.ComissionLevel2 +
                                                '","ComissionLevel3":"' +
                                                values.ComissionLevel3 +
                                                '","ComissionLevel4":"' +
                                                values.ComissionLevel4 +
                                                '","ComissionLevelBetShop":"' +
                                                values.ComissionLevelBetShop +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Valores Editados'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(url); // Reload grid data
                                                },
                                            },
                                        );
                                    this.getTopParentView().hide(); // Hide window after saving
                                },
                            },
                        ],
                    },
                ],
            },
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event on player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id, // Load data based on selected player
            );
        });

        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event on item double-click
            if (devConfig.getPermAction('permComissions', 'Edit')) {
                popup.show(); // Show edit window if permission granted
            }
        });

        $$('editformComissions').bind($$('datatable')); // Bind form to datatable
    }
}

// FILE DOCUMENTED
